// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./EN.json";
import teTranslation from "./TE.json";
import hiTranslation from "./HI.json";

i18n.use(initReactI18next).init({
  resources: {
    English: {
      translation: enTranslation,
    },
    Telugu: {
      translation: teTranslation,
    },
    Hindi: {
      translation: hiTranslation,
    },
  },
  lng: "English", // default language
  fallbackLng: "English", // fallback language
  // debug: true,
  // interpolation: {
  //   escapeValue: false, // not needed for React
  // },
});

export default i18n;
